import { InternalStockItem, InternalStockItemsQuery } from "../../inventory/models/models";
import { Page } from "../../../shared/models/models";
import api from "../../../core/api";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.inventoryApiBaseUrl };
}

class CustomerInternalStockItemApi {
  getInternalStockItems(query: InternalStockItemsQuery): Promise<Page<InternalStockItem>> {
    return api.get<Page<InternalStockItem>>(
      `/v1/supplier/internal-stock-items`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }
}

export default new CustomerInternalStockItemApi;
